module.exports = __webpack_public_path__ + "img/15.08fc1e7a.webp";